import { DateField, DateInput } from "../ui/datefield-rac";
import { DateValue } from "@internationalized/date";

interface DateInputComponentProps {
	value?: DateValue;
	onChange?: (value: DateValue | null) => void;
	className?: string;
}

const DateInputComponent = ({
	value,
	onChange,
	className,
}: DateInputComponentProps) => {
	return (
		<DateField
			value={value}
			onChange={onChange}
			className={className ?? "w-full h-11"}
		>
			<DateInput />
		</DateField>
	);
};

export {DateInputComponent};
export default DateInputComponent;
